import * as _ from 'underscore';

export function camelCase(input:string):string {
   if (input.length > 0) {
      return _.map(input.split('.'), function (s) {
         if (s.toUpperCase() === s) {
            return s.toLowerCase();
         }
         return s[0].toLowerCase() + s.slice(1);
      }).join('.');
   }

   return input;
}
